import { Listbox, Transition } from "@headlessui/react";
import React, { Fragment } from "react"
import { ReactComponent as DropdownIcon } from "../../../../../../assets/svg/solobuilder/dropdown.svg";

const InputWithOption = (props: any) => {
    let {options}:any = props.field;
    return (
        <div style={{ marginTop: "10px", display: "flex", alignContent: "center",justifyContent:"space-between" }}>
            <div style={{
                display: "flex", alignItems: "center",
                fontWeight: 500, fontSize: "11px", color: "#282B31"
            }} >{props.label}</div>
            <div className="flex panel-input">
                <div style={{ width: "48px", borderRight: "1px solid rgba(125, 132, 146, 0.3)", height: "19px" }}>
                    <Listbox value="" onChange={(e) => false} >
                        <div className="relative">
                            <Listbox.Button style={{outline:"none", width:"85%"}} className="relative flex items-center justify-between h-6 cursor-pointer bg-white outline-none">
                                {typeof props?.value?.icon === 'function' ? props?.value?.icon() : props?.value?.icon}
                                <span className="">
                                    <DropdownIcon className="h-1.5 w-1.5 ml-2 text-gray-400" />
                                </span>
                            </Listbox.Button>
                            <Transition
                                as={Fragment}
                                leave="transition ease-in duration-100"
                                leaveFrom="opacity-100"
                                leaveTo="opacity-0"
                            >
                                <Listbox.Options style={{ marginTop: "6px", marginLeft: "-5px", border: "1px solid rgba(125, 132, 146, 0.294)", boxShadow: "0px 5px 8px rgba(125, 132, 146, 0.11)", borderRadius: "4px", maxHeight: "175px", width: "45px", paddingBottom: "10px" }} className="absolute w-full overflow-auto rounded bg-white text-base focus:outline-none z-40 cursor-pointer">
                                    <div className="w-full flex flex-col items-center justify-center">
                                    {options.length && options.map((items:any, i:number) => {
                                            return (
                                        <Listbox.Option key={i} value={items}
                                            onClick={() => {
                                                let val = {...props.value, type:items.value,icon:items.icon}
                                                props?.handleChange(props.where,val)
                                            }}
                                            style={{margin: "10px 5px 0px"}}
                                            className={({ active }) =>
                                                `flex flex-col items-center justify-center w-3/4 relative cursor-pointer select-none ${active ? "hover:text-selectedText_color" : ""}`
                                            }>
                                            {({ selected }) => (
                                                <div className={`w-full ${items.icon=== props?.value?.icon ? "text-selectedText_color" : ""}`}>
                                                   {items.icon}
                                                </div>
                                            )}
                                        </Listbox.Option>
                                    )})}
                                    </div>
                                </Listbox.Options>
                            </Transition>
                        </div>
                    </Listbox>
                </div>
                <div style={{ marginLeft: "11px" }}>
                    <input style={{ outline: "none", width: "100%" }}
                        value={props?.value?.value ? props.value.value : ""}
                        onChange={(e: any) => {
                            let val = {...props.value, value:e.target.value}
                            props?.handleChange(props.where,val)
                        }}
                        placeholder="eg: 33">
                    </input>
                </div>
            </div>
        </div>
    )

}
export default InputWithOption;